var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"mb-1"},[_c('el-col',[_c('div',{staticStyle:{"width":"auto","height":"400px"},attrs:{"id":"main"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }